export const priceOptions = [
  { value: 'per_item', label: 'per item' },
  { value: 'per_person', label: 'per person' },
  { value: 'per_hour', label: 'per hour' },
  { value: 'flat_fee', label: 'flat fee' }
];

export const inventoryErrors = {
  tax_not_configurable: 'Peerspace is responsible for collecting and remitting taxes in your state.'
};